import { QueryObserverOptions, useQuery } from '@tanstack/react-query';

import { getDashboardIds, getEmbedUrl } from '../api/reporting';
import { GetDashboardsResponseDTO, GetEmbedUrlResponseDTO } from '../declarations/reporting';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';

type UseFetchDashboardIdsParamsT = {
  onSuccess: QueryObserverOptions<GetDashboardsResponseDTO, ApiErrorI>['onSuccess'];
  onError: QueryObserverOptions<GetDashboardsResponseDTO, ApiErrorI>['onError'];
};

type UseFetchEmbedUrlParamsT = {
  onSuccess: QueryObserverOptions<GetEmbedUrlResponseDTO, ApiErrorI>['onSuccess'];
  onError: QueryObserverOptions<GetEmbedUrlResponseDTO, ApiErrorI>['onError'];
};

export const useFetchDashboardIds = ({ onSuccess, onError }: UseFetchDashboardIdsParamsT) =>
  useQuery<GetDashboardsResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchDashboardIds],
    () => getDashboardIds(),
    {
      onSuccess,
      onError,
    }
  );

export const useFetchEmbedUrl = ({
  dashboardId,
  roofTopIds,
  onSuccess,
  onError,
}: UseFetchEmbedUrlParamsT & { dashboardId: string; roofTopIds: string[] }) =>
  useQuery<GetEmbedUrlResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchEmbedUrl, dashboardId, roofTopIds],
    () => getEmbedUrl(dashboardId),
    {
      enabled: !!dashboardId,
      onSuccess,
      onError,
    }
  );
